<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clip-rule="evenodd"
      d="M11.999 6.001c-3.584-.06-7.29 2.444-9.62 5.008a1.478 1.478 0 0 0 0 1.979c2.28 2.51 5.975 5.072 9.62 5.01 3.644.062 7.34-2.5 9.621-5.01a1.478 1.478 0 0 0 0-1.979C19.288 8.445 15.582 5.941 12 6.001Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      clip-rule="evenodd"
      d="M15.332 12A3.333 3.333 0 1 1 8.665 12a3.333 3.333 0 0 1 6.667.001Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
